import React, { useEffect } from 'react';
import './AchievementPopup.css';
import { useAchievement } from '../contexts/AchievementContext';
import CloseButton from './shared/CloseButton';

const AchievementPopup = () => {
    const { newAchievement, showPopup, closePopup, getAchievementStats } = useAchievement();

    // Add animation effect when popup appears
    useEffect(() => {
        if (showPopup) {
            // Play a sound effect (optional)
            const audio = new Audio('/assets/sounds/achievement.mp3');
            try {
                audio.play().catch(err => console.log('Audio play failed:', err));
            } catch (error) {
                console.log('Audio play error:', error);
            }
        }
    }, [showPopup]);

    if (!showPopup || !newAchievement) return null;

    const stats = getAchievementStats(newAchievement.id);
    const percentComplete = stats.percentage.toFixed(1);

    return (
        <div className="achievement-popup-overlay">
            <div className="achievement-popup">
                <CloseButton onClick={closePopup} variant="transparent" />
                <div className="achievement-popup-content">
                    <div className="achievement-popup-icon">{newAchievement.icon}</div>
                    <div className="achievement-popup-text">
                        <h3>Achievement Unlocked!</h3>
                        <h4>{newAchievement.title}</h4>
                        <p>{newAchievement.description}</p>
                        <p className="achievement-popup-percentage">
                            Only {percentComplete}% of players have unlocked this!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AchievementPopup; 